var _ellipse, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTabletPepiconsPencilCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 56,
    viewBox: "0 0 60 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.5,
    cy: 38.3975,
    rx: 22.5,
    ry: 8,
    fill: "#D5EEFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_620_1014)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 30.3975,
    width: 28,
    height: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8571 13.9639H15.1429C14.8398 13.9639 14.5491 14.0843 14.3347 14.2986C14.1204 14.5129 14 14.8036 14 15.1067V40.2496C14 40.5527 14.1204 40.8434 14.3347 41.0577C14.5491 41.272 14.8398 41.3924 15.1429 41.3924H44.8571C45.1602 41.3924 45.4509 41.272 45.6653 41.0577C45.8796 40.8434 46 40.5527 46 40.2496V15.1067C46 14.8036 45.8796 14.5129 45.6653 14.2986C45.4509 14.0843 45.1602 13.9639 44.8571 13.9639ZM16.2857 39.1067V16.2496H43.7143V39.1067H16.2857Z",
    fill: "#0593F5",
    stroke: "#D5EEFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0357 20.821V21.071H16.2857H43.7143H43.9643V20.821V16.2496V15.9996H43.7143H16.2857H16.0357V16.2496V20.821ZM15.1429 14.2139H44.8571C45.0939 14.2139 45.321 14.3079 45.4885 14.4754C45.6559 14.6428 45.75 14.8699 45.75 15.1067V21.9639C45.75 22.2007 45.6559 22.4278 45.4885 22.5952C45.321 22.7627 45.0939 22.8567 44.8571 22.8567H15.1429C14.9061 22.8567 14.679 22.7627 14.5115 22.5952C14.3441 22.4278 14.25 22.2007 14.25 21.9639V15.1067C14.25 14.8699 14.3441 14.6428 14.5115 14.4754C14.679 14.3079 14.9061 14.2139 15.1429 14.2139Z",
    fill: "#0593F5",
    stroke: "#D5EEFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0011 15.9992H19.7154C19.4786 15.9992 19.2515 15.9051 19.084 15.7377C18.9166 15.5702 18.8225 15.3431 18.8225 15.1063V12.8206C18.8225 12.5838 18.9166 12.3567 19.084 12.1892C19.2515 12.0218 19.4786 11.9277 19.7154 11.9277H22.0011C22.2379 11.9277 22.465 12.0218 22.6324 12.1892C22.7999 12.3567 22.8939 12.5838 22.8939 12.8206V15.1063C22.8939 15.3431 22.7999 15.5702 22.6324 15.7377C22.465 15.9051 22.2379 15.9992 22.0011 15.9992ZM40.2868 15.9992H38.0011C37.7643 15.9992 37.5372 15.9051 37.3697 15.7377C37.2023 15.5702 37.1082 15.3431 37.1082 15.1063V12.8206C37.1082 12.5838 37.2023 12.3567 37.3697 12.1892C37.5372 12.0218 37.7643 11.9277 38.0011 11.9277H40.2868C40.5236 11.9277 40.7507 12.0218 40.9181 12.1892C41.0856 12.3567 41.1797 12.5838 41.1797 12.8206V15.1063C41.1797 15.3431 41.0856 15.5702 40.9181 15.7377C40.7507 15.9051 40.5236 15.9992 40.2868 15.9992ZM20.8582 29.7134C20.3183 29.7134 19.8005 29.499 19.4188 29.1172C19.037 28.7354 18.8225 28.2176 18.8225 27.6777C18.8225 27.1378 19.037 26.62 19.4188 26.2383C19.8005 25.8565 20.3183 25.642 20.8582 25.642C21.3981 25.642 21.9159 25.8565 22.2977 26.2383C22.6795 26.62 22.8939 27.1378 22.8939 27.6777C22.8939 28.2176 22.6795 28.7354 22.2977 29.1172C21.9159 29.499 21.3981 29.7134 20.8582 29.7134Z",
    fill: "#0593F5",
    stroke: "#D5EEFF",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_620_1014"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(14 10.3975)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletPepiconsPencilCalendar);
export default __webpack_public_path__ + "static/media/tablet-pepicons-pencil_calendar.5b5b692852a58ee893743d314bba355e.svg";
export { ForwardRef as ReactComponent };